import { EndUserForm, Button } from '@alphabait/ui'
import cx from 'classnames'
import { TFunction } from 'i18next'
import { buttonText, errorT } from '../../../../../utils/ec-flow-texts'
import { NavigateFunction } from 'react-router-dom'
import i18n from '../../../../../../../client/src/i18n'
import { EndUserCampaign, PartialEndUser } from '../../../../../lib/api/types'
import { useBrand } from '../../../../../contexts/brand-context'
import { endUserType } from '../../../../../utils/user-type'
import { hasHappinessCheck } from '../../../../../utils/happiness-check'
import Header from '../../../../header'
import styles from './style.module.css'
import { cn } from '@/lib/utils'

export default function HappinessCheck({
  campaign,
  endUser,
  t,
  pathname,
  navigate,
  onSubmit,
  error,
  setError,
}: {
  campaign: EndUserCampaign
  endUser: PartialEndUser
  pathname: string
  t: TFunction<'translation', undefined>
  id?: string
  navigate: NavigateFunction
  onSubmit: (data: Record<string, unknown>) => void
  error?: string
  setError: (error: string) => void
}) {
  const { brand } = useBrand()
  const language = i18n.language
  const typeOfUser = endUserType(endUser.referral)

  const translations =
    campaign?.ecFlowTexts?.ecFlowTexts?.[typeOfUser]?.['happiness-check']?.[
    language
    ]

  if (!hasHappinessCheck(campaign)) return <div>No data</div>


  const handleFieldChange = (fieldName: string, value: unknown) => {
    // Clear error when user selects a happiness check option
    if (fieldName === 'happinessCheck' && value) {
      setError('')
    }
  }

  return (
    <div className={cx('flex flex-col w-full bg-background')}>
      <Header
        title={
          translations?.header ?? t('ec.success.title_with_happiness_check')
        }
        subTitle={translations?.text}
        pathname={pathname}
      />

      <div className={cx('w-full')}>
        <div className={cx(styles.contentWrapper)}>
          <EndUserForm brand={brand} className={cn(styles.endUsersHappinessCheck, 'bg-background rounded-md mx-auto w-full',)} fields={[...campaign.happinessCheck, {
            render: () => (<div className="flex flex-col space-y-4 py-8 justify-between h-32 my-20 px-6"> {error && (<div className="text-destructive text-sm w-full text-center"> {errorT(campaign)(error)}
            </div>
            )}
              <Button
                variant="next"
                size="lg"
                type="submit"
                data-testid="next-button"
              >
                {buttonText(campaign, 'finish', t)}
              </Button>
              <Button
                variant="back"
                onClick={() => navigate(-1)}
                data-testid="back-button"
              >
                {buttonText(campaign, 'back', t)}
              </Button>
            </div>
            ),
          },
          ]}
            onSubmit={onSubmit}
            onFieldChange={handleFieldChange}
            formClassName="w-full"
            translateError={(errorKey) =>
              errorT(campaign)(`validation_messages.${errorKey}`)
            }
          />
        </div>
      </div>
    </div>
  )
}
